var _path, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5261 17.207V52.34C18.5261 54.7996 20.52 56.7935 22.9796 56.7935H31.7216",
    stroke: "url(#paint0_linear_644_4420)",
    strokeWidth: 19.1842,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.1543,
    cy: 56.7932,
    rx: 10.5564,
    ry: 10.5564,
    fill: "url(#paint1_linear_644_4420)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_644_4420",
    x1: 25.1239,
    y1: 17.207,
    x2: 59.6864,
    y2: 44.0821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#0D5A51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_644_4420",
    x1: 44.0503,
    y1: 46.2368,
    x2: 63.8912,
    y2: 65.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#166B61"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsB2B);
export default __webpack_public_path__ + "static/media/products_b2b.85e88e1670f08d5bbb1103f31be6dfb1.svg";
export { ForwardRef as ReactComponent };